import React, { useCallback, useContext, useMemo } from "react";
import SimplePageContent from "../../components/SimplePageContent";
import { GET_PAYROLL_BREAKDOWN } from "../../graphql/timesheet";
import { useQuery } from "@apollo/client";
import Loading from "../../components/Loading";
import TimesheetList from "../../components/TimeSheetList";
import { StackScreenProps } from "@react-navigation/stack";
import { RootStackParamList } from "../../navigations/RootNavigation";
import ScreenHeader from "./ScreenHeader";
import { View } from "react-native";
import { useI18n } from "../../hooks/i18n-hooks";
import { ProfileSwitcherManagerContext } from "../../contexts/ProfileSwitcherManager";
import { buildErrorHeadband } from "../ScreenCardHeadband";

type PayrollBreakdownTimeSheetScreenProps = StackScreenProps<
    RootStackParamList,
    "PayrollBreakdownTimeSheetScreen"
>;

const PayrollBreakdownTimeSheetScreen: React.FC<PayrollBreakdownTimeSheetScreenProps> = ({
    route,
    navigation,
}) => {
    const { profileType } = useContext(ProfileSwitcherManagerContext);
    const i18n = useI18n();

    const { data, refetch, loading, error } = useQuery(GET_PAYROLL_BREAKDOWN, {
        variables: {
            payrollBreakdownId: route?.params.payrollBreakdownId || "",
        },
        fetchPolicy: "cache-and-network",
        skip: !route?.params.payrollBreakdownId,
    });
    const payrollBreakdown = data?.getPayrollBreakdown;
    const allTimeSheets = payrollBreakdown?.timesheets;

    const onBack = useCallback(() => {
        navigation.goBack();
    }, [navigation]);

    const subLabel = useMemo(() => {
        if (!data?.getPayrollBreakdown?.missionInfo) {
            return i18n.t("loading");
        }
        return data?.getPayrollBreakdown?.missionInfo?.name || "";
    }, [i18n, data]);

    return (
        <View style={{ flex: 1 }}>
            <ScreenHeader
                label={i18n.t("screens.payroll_breakdown.timesheets")}
                subLabel={subLabel}
                onLeftAction={onBack}
                hideProfile
                useSmallLabel
            />
            <SimplePageContent
                refresh={refetch}
                headband={
                    error
                        ? buildErrorHeadband(
                              i18n.t("screens.user.timesheets.cannot_load_timesheets"),
                          )
                        : undefined
                }
            >
                {loading && !allTimeSheets && <Loading />}
                {allTimeSheets && profileType && (
                    <TimesheetList
                        profileType={profileType}
                        timeSheets={allTimeSheets}
                        hideMissionName
                    />
                )}
            </SimplePageContent>
        </View>
    );
};

export default PayrollBreakdownTimeSheetScreen;
